import * as Preact from "preact"

import "./Dice.less"
import DiceFace from "./DiceFace.jsx"
import ItemBreakdown from "./ItemBreakdown.jsx"

export default class Dice {
    render() {
        let {item, isAnimated, isHighlighted, isLabeled, includeDescription, anchored, index} = this.props
        if(item === undefined) return
        if(item === null) {
            return (
                <div class="Null Dice">
                    <div class="DiceFace"/>
                </div>
            )
        }

        // TODO: move this to a centralized function, called both in DiceFace and Dice and other places.
        let power = ((item.power || 0) + (this.props.unit.power || 0))
        if(this.props.item.powerboost instanceof Function) {
            power += this.props.item.powerboost({"stage": this.props.stage, "unit": this.props.unit, "item": this.props.item})
        }

        return (
            <div class="Dice" isPressed={this.isPressed} anchored={anchored || (index % 2 == 0 ? "top" : "bottom") || "top"} index={index} isLabeled={isLabeled} isAnimated={isAnimated} isHighlighted={isHighlighted}
                onMouseDown={this.onMouseDown()} onMouseUp={this.onMouseUp()} onMouseOut={this.onMouseOut()} onMouseOver={this.onMouseOver()}>
                <div class="Label">
                    <div class="Title"><span>{item.title || "???"}</span></div>
                </div>
                <ItemBreakdown item={item} unit={this.props.unit} stage={this.props.stage}/>
                <DiceFace item={item} unit={this.props.unit} stage={this.props.stage}/>
            </div>
        )
    }
    onMouseDown() {
        return (event) => {
            if(event.button != 2) return
            event.stopPropagation()
            window.hasRightClicked = true
            this.isPressed = true
        }
    }
    onMouseUp() {
        return (event) => {
            if(event.button != 2) return
            event.stopPropagation()
            window.hasRightClicked = true
            this.isPressed = false
        }
    }
    onMouseOut() {
        return (event) => {
            event.stopPropagation()
            this.isPressed = false
        }
    }
    onMouseOver() {
        return (event) => {
            if(event.button != 2 && event.buttons != 2) return
            event.stopPropagation()
            this.isPressed = true
        }
    }
}
